module.exports = __webpack_public_path__ + "img/interactive.1a29ebaf.svg";